module.exports = __webpack_public_path__ + "img/logo-lg@2x.a1a3ccfe.png";